// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1aAJD","productName":"Table_productName__2Btcd"};